import { object } from "yup";

import { emailValidationSchema } from "utils/yup/emailValidationSchema";
import { validationMessages } from "utils/yup/validationMessages";

export const remindPasswordValidationSchema = object().shape({
  email: emailValidationSchema.required(validationMessages.requiredField),
});
